import {TableRequest} from '../api/table-request';
import {OrdersTradesFilter} from './orders-trades-filter';

export class OrdersTradesTableRequest extends TableRequest {

  visibleFields?: string[];
  stateFilter: OrdersTradesFilter.StateFilter = OrdersTradesFilter.StateFilter.ALL;
}

